// src/routes/dashboard/components/DeltaBadge.tsx
/** Badge di variazione rispetto allo stesso periodo del mese scorso, con tooltip esplicativo. */
import React from 'react';
import { Badge, Tooltip } from '@mantine/core';
import { IconArrowUpRight, IconArrowDownRight, IconMinus, IconSparkles } from '@tabler/icons-react';
import { formatDelta } from '../dashboard-meta';

const TONE_COLOR: Record<string, string> = {
  up: 'teal',
  down: 'red',
  flat: 'gray',
  new: 'blue',
};

const TONE_ICON: Record<string, React.ReactNode> = {
  up: <IconArrowUpRight size={12} />,
  down: <IconArrowDownRight size={12} />,
  flat: <IconMinus size={12} />,
  new: <IconSparkles size={12} />,
};

interface DeltaBadgeProps {
  current: number;
  previous: number;
  /** Se true, un aumento è "negativo" (es. richieste in ritardo): inverte i colori up/down. */
  invert?: boolean;
  tooltipRange?: string;
}

export function DeltaBadge({ current, previous, invert = false, tooltipRange }: DeltaBadgeProps) {
  const { text, tone } = formatDelta(current, previous);
  const effectiveTone = invert && (tone === 'up' || tone === 'down') ? (tone === 'up' ? 'down' : 'up') : tone;

  const badge = (
    <Badge
      color={TONE_COLOR[effectiveTone]}
      variant="light"
      size="sm"
      leftSection={TONE_ICON[effectiveTone]}
    >
      {text}
    </Badge>
  );

  return (
    <Tooltip
      label={`Rispetto allo stesso periodo del mese scorso${tooltipRange ? ` (${tooltipRange})` : ''}`}
      multiline
      w={220}
      withArrow
    >
      {badge}
    </Tooltip>
  );
}
